import axios, { AxiosPromise } from 'axios';

const uri = '/home/log';

export const postLog = (data: any): AxiosPromise => {
  return axios.post(uri, data);
};